import React, { useEffect, useCallback } from 'react'
import useIsMounted from '../../../../../../hooks/useIsMounted'
import OutOfStockItems from './OutOfStockItems'
import { usePopUpContext } from '../../../providers/PopUpProvider'

const CheckStock = params => {
  const {
    data,
  } = params
  const { items } = data

  const {
    showOosProducts, shouldShowOosProducts,
    outOfStockItems, setOutOfStockItems,
    shouldShowOosNotifyForm,
  } = usePopUpContext()

  const isMounted = useIsMounted()

  const handleCheckStock = useCallback(
    () => {
      setOutOfStockItems([])
      if (items && items.length) {
        const oosItems = items
          .filter(item => item.inventory && item.inventory.quantity < 1) || []

        if (oosItems.length) {
          setOutOfStockItems(oosItems)
          shouldShowOosProducts(true)
          shouldShowOosNotifyForm(false)
        }
      }
    },
    [shouldShowOosProducts, setOutOfStockItems, items, shouldShowOosNotifyForm],
  )

  useEffect(
    () => {
      if (__BROWSER__ && isMounted()) {
        handleCheckStock()
      }
    },
    [isMounted, handleCheckStock],
  )

  return outOfStockItems && outOfStockItems.length > 0 && (
    <OutOfStockItems
      data={outOfStockItems}
      showOosProducts={showOosProducts}
      shouldShowOosProducts={shouldShowOosProducts}
    />
  )
}

export default CheckStock
